export const FETCH_USER_BONUS_DATA = 'deposit-bonus/fetchUserBonusData';
export const REGISTER_USER_FOR_BONUS = 'deposit-bonus/registerUserForBonus';
export const SET_SELECTED_BONUS = 'deposit-bonus/setSelectedBonus';
